<template>

  <div 
    class         = "reply-container pt-2"
  >

    <Avatar :user="reply.user"></Avatar>

    <div 
      class     = "triangle ml-2 mt-2"
      :class    = "{hidden: isBeingEdited}"
    >
    </div>

    <div class="text pr-2">

      <!-- Text Entry -->
      <v-textarea
        class     = "text-body-2"
        v-if      = "isBeingEdited"
        v-model   = "text"
        outlined
        autofocus
        dense
        auto-grow
        rows      = "1"
        hide-details
        @blur         = "onSaveChanges"
        @keydown.esc  = "onRejectChanges"
      >
      </v-textarea>

      <!-- Text Display -->
      <div 
        v-else
        class   = "pa-2 text-body-2 not-editing"
        :class  = "{ editable: canEdit }"
        @click  = "onEditReply"
      >
        {{ reply.text }}
      </div>

    </div>

    <!-- Remove -->
    <v-btn
      icon
      :disabled = "!canEdit"
      @click    = "onRemoveReply(reply.id);"
    >
      <v-icon>mdi-comment-remove-outline</v-icon>
    </v-btn>

    <ConfirmationDialog ref="confirmation_dialog"></ConfirmationDialog>

  </div>

</template>

<script>


// #region Imports

/* Vuex */
import { mapState } from 'vuex';

/* Telestream */
import { 
  UPDATE_ANNOTATION_REPLY,
  REMOVE_ANNOTATION_REPLY
} from '@/utils/action-types';
import {
  SET_REPLY_BEING_EDITED
} from '@/utils/mutation-types';
import Avatar from './Avatar';
import ConfirmationDialog from '../dialogs/ConfirmationDialog';

// #endregion Imports

export default {

  // #region Properties

  props: {
    annotationId: String,
    reply:        Object
  },
  data() {
    return {
      text: ''
    };
  },
  computed: {
    ...mapState([
      'ui',
      'user'
    ]),
    avatar() {
      return this.reply.user.charAt(0);
    },
    canEdit() {
      return this.user.name === this.reply.user;
    },
    isBeingEdited() {
      return (this.ui.replyBeingEdited === this.reply.id);
    }
  },
  components: {
    Avatar,
    ConfirmationDialog
  },

  // #endregion Properties

  // #region Life-Cycle

  mounted() {
    this.text = this.reply.text;
  },

  // #endregion Life-Cycle
  
  // #region Methods

  methods: {

    onEditReply() {
      this.text = this.reply.text;
      this.$store.commit(SET_REPLY_BEING_EDITED, this.reply.id);
    },

    onSaveChanges() {
      const updatedReply = {
        ...this.reply,
        text: this.text
      };

      this.$store.dispatch(
        UPDATE_ANNOTATION_REPLY, 
        {
          annotationId: this.annotationId, 
          updatedReply: updatedReply 
        }
      );

      this.$store.commit(SET_REPLY_BEING_EDITED, undefined);
    },

    async onRemoveReply(replyId) {
      if (await this.$refs.confirmation_dialog.confirm(
        'Remove Reply?',
        'Are you sure you want remove your reply?',
        'Remove Reply',
        'error',
        'Keep Reply',
        'primary'
      )) {
        this.$store.dispatch(
          REMOVE_ANNOTATION_REPLY, 
          {
            annotationId: this.annotationId,
            replyId:      replyId
          }
        );
      }
    }

  }

  // #endregion Methods

}

</script>

<style lang="scss" scoped>

.reply-container {
  display:                flex;

  .text {
    flex:           1;

    .not-editing {
      background-color:   rgba(255, 255, 255, 0.15);
      border-radius:      4px;
      white-space:        pre-line;
      word-break:         break-word;

      &.editable {
        cursor:             pointer;
      }
    }
  }

  $triangle-size: 9px;

  .triangle {
    width: 0; 
    height: 0; 
    border-top:     $triangle-size solid transparent;
    border-bottom:  $triangle-size solid transparent; 
    
    border-right:   $triangle-size solid rgba(255, 255, 255, 0.15); 

    &.hidden {
      border-right-color: transparent;
    }
  }

}

</style>
